// extracted by mini-css-extract-plugin
export default {"card":"styles_card__BTxKK","block":"styles_block__t5ldv","title":"styles_title__Du8Qx","detailBlock":"styles_detailBlock__Rd9O+","item":"styles_item__GhgfK"};